import handles_errors from "./HandlesErrors"

const handles_saving = {
    mixins: [handles_errors],
    methods: {
        save_data_for_record_id (entity, record_id, data) {
            return this.$store.dispatch("RECORD_SAVE", {
                entity: entity,
                id: record_id,
                data
            }).catch(this.receive_error)
        },
        save_field_for_record_id (entity, record_id, value, field) {
            if(this.saving_field_ids.indexOf(field) < 0) this.saving_field_ids.push(field)

            if(typeof value === "undefined") value = null

            this.clear_error(field)
            return this.save_data_for_record_id(entity, record_id, { [field]: value }).then(() => {
                const index = this.saving_field_ids.indexOf(field)
                if(index >= 0) this.saving_field_ids.splice(index, 1)
            })
        },
        save_field (value, field) {
            return this.save_field_for_record_id(this.entity, this.record_id, value, field)
        },
        saving (field) {
            return (this.saving_field_ids.indexOf(field) >= 0)
        }
    },
    data () {
        return {
            record_id: 0,
            saving_field_ids: [],

            // NEEDS TO BE OVERRIDEN
            entity: ""
        }
    }
}

export default handles_saving
